import { ICustomSnackBarProps } from '@app/models/shared.models';
import { Snackbar, Theme } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import * as React from 'react';
import Icon from './icon.component';

const defaultProps: ICustomSnackBarProps = {
	open: false,
	anchorOrigin: {
		horizontal: 'right',
		vertical: 'top',
	},
	autoHideDuration: 2000,
	onClose: () => {},
	disableWindowBlurListener: false,
};

const variantIcon = {
	error: 'exclamation-circle',
	info: 'info-circle',
	success: 'check-circle',
};

const snackBarStyle = (theme: Theme) => ({
	icon: {
		fontSize: 20,
	},
	iconVariant: {
		marginRight: theme.spacing(),
		opacity: 0.9,
	},

	message: {
		alignItems: 'center',
		display: 'flex',
	},

	info: {
		backgroundColor: theme.palette.info.main,
	},
	error: {
		backgroundColor: theme.palette.error.main,
	},
	success: {
		backgroundColor: theme.palette.success.main,
	},
});

const CustomSnackBar = (props: ICustomSnackBarProps) => {
	const {
		classes,
		defaultCloseAction = true,
		action = [],
		variant,
		onIconClick,
		children,
		snackBarMessage,
		...restSnackBarProps
	} = props;
	let snackBarMsg = snackBarMessage;
	const iconName = variantIcon[variant];
	if (!Array.isArray(snackBarMsg)) {
		snackBarMsg = [snackBarMsg];
	}
	const message = children || (
		<span className={classNames(classes.message)}>
			<Icon name={iconName} className={classNames(classes.icon, classes.iconVariant)} />
			{snackBarMsg.map((x, i) => (
				<React.Fragment key={i}>
					{x} <br />
				</React.Fragment>
			))}
		</span>
	);
	action.push(
		...(defaultCloseAction
			? [
					<IconButton key='close' aria-label='Close' color='inherit' onClick={onIconClick}>
						<Icon name='times' />
					</IconButton>,
			  ]
			: [])
	);

	return (
		<Snackbar
			ContentProps={{
				className: classNames(classes[variant]),
				message,
				action,
			}}
			{...restSnackBarProps}
		/>
	);
};

CustomSnackBar.defaultProps = defaultProps;

export default withStyles(snackBarStyle)(CustomSnackBar);



// WEBPACK FOOTER //
// ./src/components/shared/snackbar.component.tsx